module.exports = __webpack_public_path__ + "static/herotablet-bd6d4d4a5f20751e10175aaaa333bd11.jpg";